import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme);

  const ex1 = await getThemePic(data?.customTheme, "ex-1");

  return {
    id: id,
    elements: [
      {
        type: "image",
        id: "2bdGCR2Uc-",
        src: ex1,
        width: 384.77055969707726,
        height: 384.77055969707726,
        left: 145.503727369542,
        top: 121.86130398769369,
        fixedRatio: true,
        rotate: 0,
      },
      {
        type: "shape",
        id: "zUvyFbgCba",
        width: 31.240496982605602,
        height: 146.42,
        left: 276.4495030173944,
        top: 134.83,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "none",
        fixedRatio: false,
        rotate: 0,
        text: {
          content:
            '<p style="text-align: center;"><strong><span style="font-size: 24px;"><span style="font-family: PingFang SC;">CONTENTS</span></span></strong></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "top",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "shape",
        id: "HT9gYgir8l",
        width: 111.12826056088036,
        height: 189.64751508697196,
        left: 324.2560868536268,
        top: 162.4644101289788,
        viewBox: [200, 200],
        path: "M 0 0 L 200 0 L 200 200 L 0 200 Z",
        fill: "none",
        fixedRatio: false,
        rotate: 0,
        text: {
          content:
            '<p style="text-align: center;"><strong><span style="font-size: 76px;"><span style="font-family: Arial;">目</span></span></strong></p><p style="text-align: center;"><strong><span style="font-size: 76px;"><span style="font-family: Arial;">录</span></span></strong></p>',
          defaultFontName: "Microsoft Yahei",
          defaultColor: "#333",
          align: "top",
        },
        flipH: false,
        flipV: false,
      },
      {
        type: "text",
        id: "9Vr9lL-uNl",
        width: 37.21,
        height: 60,
        left: 0,
        top: 0,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        content:
          '<p style="text-align: left;"><span style="font-size: 1.02px;font-family: Arial;">行业</span><span style="font-size: 1.02px;font-family: Arial;">PPT</span><span style="font-size: 1.02px;font-family: Arial;">模板</span><span style="font-size: 1.02px;font-family: Arial;">http://www.1ppt.com/hangye/</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "FKQsx5EgLg",
        left: 693.4541792547834,
        top: 157.23308734055047,
        width: 361.664988251091,
        height: 241.921875,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#333",
        vertical: false,
      },
    ],
    background,
  };
}
